import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createTeam } from "../../../../services/team";
import { useEffect, useState } from "react";
import { getClubOptions } from "../../../../services/club";
import { Category } from "../../../../interfaces/category";
import { Club } from "../../../../interfaces/club";
import { getCategoryOptions } from "../../../../services/category";
import { getModalityOptions } from "../../../../services/modality";
import { Modality } from "../../../../interfaces/modality";

interface AdminTeamNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminTeamNew(props: AdminTeamNewProps) {
    const [clubs, setClubs] = useState<Club[]>([]);
    const [modalities, setModalities] = useState<Modality[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubs(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        
        getModalityOptions()
            .then(response => {
                setModalities(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        
        getCategoryOptions()
            .then(response => {
                setCategories(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            club_id: event.target.club_id.value,
            modality_id: event.target.modality_id.value,
            category_id: event.target.category_id.value
        }
        createTeam(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="admin-team-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_team") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="club_id">
                            <Form.Label aria-required="true">{ t("club") }</Form.Label>
                            <Form.Select aria-label={ t("club") } required>
                                <option value="">{ t("select_club") }</option>
                                { clubs.map((c: Club) => {
                                    return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="modality_id">
                            <Form.Label aria-required="true">{ t("modality") }</Form.Label>
                            <Form.Select aria-label={ t("modality") } required>
                                <option value="">{ t("select_modality") }</option>
                                { modalities.map((m: Modality) => {
                                    return <option key={ 'modality-' + m.id } value={ m.id }>{ m.name }</option>;
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="category_id">
                            <Form.Label aria-required="true">{ t("category") }</Form.Label>
                            <Form.Select aria-label={ t("category") } required>
                                <option value="">{ t("select_category") }</option>
                                { categories.map((c: Category) => {
                                    return <option key={ 'category-' + c.id } value={ c.id }>{ c.name }</option>;
                                })}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}